module.exports = __webpack_public_path__ + "img/hour-glass.552b0728.svg";